<template>
    <div
        class="EvieSidebarConversationItem"
        :class="{ 'EvieSidebarConversationItem--active': isActive }"
        @click="$emit('click')"
    >
        <div class="EvieSidebarConversationItem__header">
            <p class="EvieSidebarConversationItem__title">
                {{ summary.title }}
            </p>
            <EidIcon
                v-if="isStreaming && !isActive"
                class="EvieSidebarConversationItem__streamingSpinner animate-spin"
                :icon-src="faSpinner"
            />
            <NewButton
                v-else
                class="EvieSidebarConversationItem__renameBtn"
                variant="flat"
                color="neutral"
                size="icon-xxs"
                type="button"
                aria-label="Rename conversation"
                @click.stop="openRenameModal"
            >
                <EidIcon :icon-src="faPen" />
            </NewButton>
        </div>
    </div>
</template>

<style lang="scss">
.EvieSidebarConversationItem {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    background: transparent;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: var(--eidQualityBlack-10);
    }

    &--active {
        background: var(--eidSecureBlue-10);
    }

    &__header {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    &__title {
        flex: 1;
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0;
    }

    &__renameBtn {
        flex-shrink: 0;
        opacity: 0;

        .EvieSidebarConversationItem:hover & {
            opacity: 1;
        }
    }

    &__streamingSpinner {
        flex-shrink: 0;
        font-size: 12px;
        color: var(--eidSecureBlue-50);
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faSpinner } from '@fortawesome/pro-light-svg-icons';
    import { faPen } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { EvieConversationSummary } from '@evidentid/tprm-portal-lib/models/evie/EvieConversationSummary.model';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'EvieSidebarConversationItem',
        components: { NewButton, EidIcon },
        props: {
            summary: { type: Object as PropType<EvieConversationSummary>, required: true },
            isActive: { type: Boolean, default: false },
            isStreaming: { type: Boolean, default: false },
            rpName: { type: String, required: true },
        },
        emits: [ 'click' ],
        data() {
            return { faPen, faSpinner };
        },
        methods: {
            openRenameModal() {
                (this as any).$procedures.execute('evieRenameConversationProcedure', {
                    rpName: this.rpName,
                    conversationId: this.summary.conversationId,
                    currentTitle: this.summary.title,
                });
            },
        },
    });
</script>
